import React, { useEffect, useRef } from 'react';

// Custom useEffectHook, não será chamado quando o componente renderiza pela primeira vez
// Útil para evitar chamadas desnecessárias à api's 
const useDidMountEffect = (func, deps) => {
    const didMount = useRef(false);

    // react renderiza quando estado altera, mas não na primeira renderização
    useEffect(() => {
        if (didMount.current) func();
        else didMount.current = true;
    }, deps);
}

export default useDidMountEffect; 